import md5 from 'md5'
import qs from 'qs'

import request from '@/utils/request'

// 获取验证码的sign
function getSliderSign({ areaCode = '+86', mobile }: any) {
  const timestamp = new Date().getTime()
  const signC = 'er$N@i&2Kc^m9d$'
  const str = `timestamp-${timestamp}-area-${areaCode}-mobile-${mobile}-${signC}`
  return { signL: md5(md5(str) + `-${signC}`), timestamp }
}

interface ResType<T> {
  data: T
  msg: string
  status: number
}

// 登录-登录接口
export const login = (data: any) => {
  return request({
    url: `/pc_api/api/pc/v1/pcLogin`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 登录-登出接口
export const logout = (data: any) => {
  return request({ url: `/pc_api/api/pc/logout/device`, method: 'post', data: qs.stringify(data) })
}

// 注册
export const register = (data: any) => {
  return request({
    url: `/pc_api/api/pc/nuserReg`,
    method: 'post',
    data: qs.stringify({
      type: 'REG',
      ...data
    })
  })
}

// 获取是否需要滑块验证
export function isOpenHK() {
  return request({
    url: '/xbk_api/api/v1/tripartite/isOpenHK',
    method: 'post'
  })
}

// 登录-获取验证码
export const getSmsCode = (data: any) => {
  const sign = getSliderSign(data)
  return request({
    url: `/pc_api/api/pc/v1/getSmsCodeWithVer`,
    method: 'post',
    data: qs.stringify({
      ...data,
      identity: '2'
    }),
    headers: {
      ...sign
    }
  })
}

// 重置密码
export const resetPwd = (data: any) => {
  return request({ url: `/pc_api/api/pc/userForget`, method: 'post', data: qs.stringify(data) })
}

// 地区
export const getAreaList = (): any => {
  return request({ url: `/pc_api/api/pc/getAreaList`, method: 'post', data: {} })
}

// 获取销售id
export const getUserOfSales = (id: number) => {
  const timestamp = (Date.now() / 1000).toFixed(0)
  return request({
    url: `/1v1k8s/crm/api/v1/lead/getMySalesInfo?uid=${id}&timestamp=${timestamp}&sign=${md5(`${id}_${timestamp}`)}`,
    method: 'post',
    headers: {
      Authorization:
        'Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiJhZG1pbiIsInN1YiI6ImFkbWluIiwiaWF0IjoxNjg3MzM1MTY1LCJhdWQiOiJhZG1pbiIsImV4cCI6MjU1MTMzNTE2NX0.iIx8DUIQ9ryi9e4SfkwLIWx2Fp-_PG9iFO-N4gQIHCJLp0Z667jNUcvqajhbwWgjqoMwJbLxeaz199l23wC9UQ'
    }
  })
}

// 获取销售二维码
export const getSalesInfo = (data: any) => {
  return request({
    url: `/1v1k8s/qwx/api/v1/qwx/contactMe/addContactMe`,
    method: 'post',
    data: qs.stringify(data),
    headers: {
      Authorization:
        'Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiJhZG1pbiIsInN1YiI6ImFkbWluIiwiaWF0IjoxNjg3MzM1MTY1LCJhdWQiOiJhZG1pbiIsImV4cCI6MjU1MTMzNTE2NX0.iIx8DUIQ9ryi9e4SfkwLIWx2Fp-_PG9iFO-N4gQIHCJLp0Z667jNUcvqajhbwWgjqoMwJbLxeaz199l23wC9UQ'
    }
  })
}
// 保证用户活性
export const putDevice = (data: any) => {
  return request({
    url: `/xbk_api/api/log/active/device`,
    headers: {
      ...data
    },
    method: 'post',
    data
  })
}

// 弹窗添加课程顾问企微
export const popupAddQweChat = () => {
  return request({
    url: '/pc_api/api/pc/qweChat/popupAddQweChat',
    headers: {
      userid: localStorage.userid
    },
    method: 'post'
  })
}
